import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { GasInputModule } from '../../forms/gas-input/gas-input.module';
import { GasRangeComponent } from './gas-range.component';
import { GasNumberRangeComponent } from './gas-number-range/gas-number-range.component';
import { GasDatepickerRangeComponent } from './gas-datepicker-range/gas-datepicker-range.component';

const COMPONENTS = [
  GasRangeComponent,
  GasNumberRangeComponent,
  GasDatepickerRangeComponent,
];

@NgModule({
  declarations: [COMPONENTS],
  imports: [
    CommonModule,
    GasInputModule,
    ReactiveFormsModule,
  ],
  exports: [COMPONENTS],
})
export class GasRangeModule {
}
